export default __webpack_public_path__ + "static/media/ExpressOne.108cce79.svg";